<template>
  <div class="wrapper">
    <template v-if="Object.values(data.connections || []).indexOf('api') != -1">
      <h6 class="card-title">Steps to authorise your account:</h6>
      <ul>
        <li>
          Register a new application using the following URL:
          <a href="https://developers.etsy.com/documentation/tutorials/quickstart#get-your-api-key" target="_blank">Register Application</a>
        </li>
        <li>Please fill in the information on the form below (* indicates required fields)</li>
        https://www.etsy.com/developers/edit/&lt;Application Id&gt;/callbacks
        <li>At the URL Auth section, click the "get" button</li>
        <li>Use the received URL and paste it into the browser, then grant API permission</li>
        <li>After granting permission, the browser will return a URL in the following format: https://&lt;callback URL&gt;?code=<b>&lt;abcd...&gt;</b>&amp;state=&lt;wxyz...&gt;. Copy the received code and paste it into Authentication -&gt; Code</li>
        <li>Click "Request access" to complete the authentication process</li>
      </ul>
    </template>
    <div class="etsy_popup_wrap">
      <div class="etsy_popup_container row">
        <div class="position-relative form-group col-12">
          <span>ID:&nbsp;</span>
          <span class="select-all">{{ data.id }}</span>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <small class="form-text text-muted mt-0">
            <a class="get_etsy_account_name" href="https://www.etsy.com/your/shops/me?ref=seller-platform-mcnav" target="#">Get Shop Name</a>
          </small>
          <input class="form-control mt-2" type="text" name="name" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" :readonly="action == 'view'"/>
        </div>
        <div class="position-relative form-group col-12 pl-0 pr-0 mb-0">
          <label class="col-12">Connect by</label>
          <div class="col-12 mb-3">
            <Select :options="more.connections" :value="data.connections" @changeValue="store.commit('connections', $event)" multiple :disabled="action == 'view'"></Select>
          </div>
        </div>
        <div v-show="Object.values(data.connections || []).indexOf('api') != -1 && action != 'view'" class="col-12 mb-0">
          <div class="position-relative form-group col-12 pl-0 pr-0 pt-2 mb-2 boder-dashed">
            <label class="col-12">API</label>
            <div class="position-relative form-group col-12 pl-0 pr-0">
              <label class="col-12">Proxy*</label>
              <div class="input-group col-4 pr-2">
                <Select :options="proxyType" :value="integration.api.proxy_type" @changeValue="store.commit('integration.api.proxy_type', $event)"></Select>
              </div>
              <div class="input-group col-8 pl-2">
                <input name="proxy" type="text" class="form-control" placeholder="ip:port:user:password" :value="integration.api.proxy" @change.stop.prevent="store.commit('integration.api.proxy', $event.target.value)" />
              </div>
            </div>
            <div v-show="integration.api.api_relation || !integration.api.api_secret" class="col-12 mb-3">
              <Select source="token/search" field="etsy" placeholder="Token" :value="integration.api.api_relation" @changeValue="store.commit('integration.api.api_relation', $event)"></Select>
            </div>
            <div v-show="!integration.api.api_relation" class="input-group col-6 pr-2 mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Key</span>
              </div>
              <input name="api_key" type="text" class="form-control" :value="integration.api.api_key" @change.stop.prevent="store.commit('integration.api.api_key', $event.target.value)" />
            </div>
            <div v-show="!integration.api.api_relation" class="input-group col-6 pl-2 mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text">Secret</span>
              </div>
              <input name="api_secret" type="text" class="form-control" :value="integration.api.api_secret" @change.stop.prevent="store.commit('integration.api.api_secret', $event.target.value)" />
            </div>
            <div v-show="!integration.api.api_relation" class="input-group col-12 mb-3">
              <input name="callback_url" type="text" class="form-control w-100" placeholder="https://example.com/auth/etsy" :value="integration.api.callback_url" @change.stop.prevent="store.commit('integration.api.callback_url', $event.target.value)" />
              <small>Callback URLs registered in your application</small>
            </div>
            <div v-show="integration.api.api_relation || (integration.api.api_key && integration.api.api_secret)" class="input-group col-12 mb-3">
              <label class="mb-0">URL Auth</label>
              <button type="submit" class="btn btn-light ml-2 pt-0 pb-0" @click.stop.prevent="getAuthorizationUrl">Get</button>
              <span class="input-group select-all" style="word-break: break-all">{{ authUrl }}</span>
              <small v-if="!integration.api.api_verifier">Click get button to generate authentication url</small>
            </div>
            <div v-if="integration.api.api_verifier && authUrl" class="position-relative form-group col-12">
              <label class="mb-0">Authentication</label>
              <button type="submit" class="btn btn-light ml-2 pt-0 pb-0" @click.stop.prevent="requestAccessToken">Request access</button>
              <div class="input-group col-12 mt-2 pl-0 pr-0">
                <div class="input-group-prepend">
                  <span class="input-group-text">Code</span>
                </div>
                <input name="auth_code" type="text" class="form-control" :value="integration.api.api_code" @change.stop.prevent="store.commit('integration.api.api_code', $event.target.value)" />
              </div>
              <small>Code is received after granting access permission</small>
            </div>
          </div>
        </div>
        <div v-show="Object.values(data.connections || []).indexOf('orderdesk') != -1 && action != 'view'" class="position-relative form-group col-12 mb-0">
          <OrderDeskEdit :config="{ storeId: storeId.concat('integration.orderdesk') }" class="position-relative form-group col-12 pl-0 pr-0 pt-2 mb-2 boder-dashed"></OrderDeskEdit>
        </div>
        <div v-show="Object.values(data.connections || []).indexOf('remote') != -1" class="position-relative form-group col-12">
          <div class="position-relative form-group col-12 pb-2 pt-2 mb-2 boder-dashed">
            <label class="mb-0">Token</label>
            <button type="submit" class="btn btn-primary ml-2 pt-0 pb-0" @click.stop.prevent="getAccountToken">Get</button>
            <button v-if="action != 'view'" type="submit" class="btn btn-light ml-2 pt-0 pb-0" @click.stop.prevent="revokeAccountToken">Revoke</button>
            <p class="select-all mb-0 mt-2">{{ integration?.remote?.account_token }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'
import OrderDeskEdit from '@/platforms/OrderDesk/SaleAccount/Modal/Edit.vue'

export default {
  mixins: [Event],
  components: {
    OrderDeskEdit
  },
  data() {
    return {
      authUrl: null,
      proxyType: [
        {
          id: 'http',
          text: 'Http'
        },
        {
          id: 'socks',
          text: 'Socks'
        }
      ]
    }
  },
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    extraUri() {
      return `sale-account/extra/${this.accountId}`
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    },
    meta() {
      return this.data.meta || {}
    },
    integration() {
      return _.mergeLeft(
        {
          api: {
            proxy: '',
            proxy_type: '',
            callback_url: '',
            api_key: '',
            api_secret: '',
            api_relation: ''
          },
          orderdesk: {
            api_key: '',
            api_secret: ''
          },
          remote: {
            token: ''
          }
        },
        this.data.integration || {}
      )
    },
    more() {
      return this.data.more || {}
    }
  },
  mounted() {
    this.$emitter.on('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  methods: {
    getAuthorizationUrl(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'get-authorization-url',
        connection: 'api'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: (response) => {
          if (response.status == 'success') {
            this.authUrl = response.data.url
            this.store.commit('integration.api.api_verifier', response.data.verifier)
          }
        }
      })
    },
    requestAccessToken(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'request-access-token'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: (response) => {
          if (response.status == 'success') {
            this.authUrl = null
          }
        }
      })
    },
    getAccountToken(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'get-account-token',
        connection: 'remote'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: ({ status, account_token }) => {
          if (status == 'success') {
            this.store.commit('integration.remote.account_token', account_token)
          }
        }
      })
    },
    revokeAccountToken(e) {
      let data = Object.assign(this.store.getter(''), {
        action: 'revoke-account-token',
        connection: 'remote'
      })

      this.$util.post(this.extraUri, data, e.target, {
        done: ({ status }) => {
          if (status == 'success') this.store.commit('integration.remote.account_token', null)
        }
      })
    },
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
